import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { apiClient } from '../../../utils/axios';

export const getSalesDocumentPeppolData = async ({ queryKey }) => {
  const [, docId, documentType, searchQuery] = queryKey;

  const { data } = await apiClient.get(`/sales-${documentType}/${docId}/peppol-status`, {
    params: searchQuery,
    skipErrorSnackbar: true,
  });
  return data;
};

export const getPurchaseDocumentPeppolData = async ({ queryKey }) => {
  const [, docId, documentType, searchQuery] = queryKey;

  const { data } = await apiClient.get(`/purchase-${documentType}/${docId}/peppol-status`, {
    params: searchQuery,
    skipErrorSnackbar: true,
  });
  return data;
};

export const useGetPeppolDataHandler = (documentType, docId, isPurchase, searchQuery = {}) => {
  const [peppolData, setPeppolData] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [`peppolData-${documentType}`, docId, documentType, searchQuery],
    queryFn: isPurchase ? getPurchaseDocumentPeppolData : getSalesDocumentPeppolData,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 0,
  });

  useEffect(() => {
    if (fetchedData) {
      setPeppolData(fetchedData);
    }
  }, [fetchedData]);

  return {
    peppolData,
    isLoading,
    isError,
  };
};
